import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute,Params } from '@angular/router';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { RespPerson, DailyToken, MSCDayToken, DailyTokenItem, DPHToken,Plan, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import { MaterialShortage, MSCToken } from '../../shared/misc-classes';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';


@Component({
  selector: 'app-mat-short',
  templateUrl: './mat-short.component.html',
  styleUrls: ['./mat-short.component.css']
})
export class MatShortComponent implements OnInit {
  btnName:string = '';

  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editParam1:any;
  editParam2:any;
  copySelDate:Date = new Date();
  copyDataObj:MaterialShortage;
  CopyMSCDayTokenObj:Array<MSCToken>=[];

  editRow:MSCToken;
  currMonthDtObj:Date = new Date();
  datatables:MaterialShortage;
  dMSCDayTokenObj:MSCDayToken;
  

  isLoading: boolean = false;
  isLoaded: boolean = false;
  isFailed: boolean = false;
  failMessage: string = '';

  selView: number = 1;
  planObj:Plan;
  areChangesMade:boolean = false;

  mId:string = "ad73bba3-1e0a-47a6-da4b-4819468fadbc";
  hasmodaccess:boolean = false;
  daywiseItemList: Array<DailyToken>;

  
  
  @ViewChild('childModal') public childModal:ModalDirective; 
  @ViewChild('copyModal') public copyModal:ModalDirective; 
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(public _dataService:DataService,
              private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Focus Area";

    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));        
      }
      this.loadMonthData();
      this.loadPlan();
    });
  }

  savePlan(){
    this._dataService.savePlan(this.planObj).subscribe((resp: GenResponse) => {
      if (resp.status == DataService.statusFail) {
        if (resp.errorCode == DataService.staleDataCode) {
          this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
        } else {
          this._notify.error('Failure', resp.details, this._dataService.failureOptions);
        }
      }
      else {
        this._notify.success('Success', resp.details, this._dataService.successOptions);
        this.loadMonthData();
        this.loadPlan();
      }

    });
  }
  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }

  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  loadPlan(){
    this._dataService.loadPlan(this.currMonthDtObj).subscribe((_dailyProdHigh: Plan) => {
      if (_dailyProdHigh != null) {
        this.planObj = _dailyProdHigh;
      }
    });
  }
  loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadMaterialShortage(this.currMonthDtObj).subscribe((_dataTables:MaterialShortage) => {
        if(_dataTables!=null){
          this.datatables = _dataTables;
          this.loadDateData();
    
          let _tmpDailyTokenList: Array<DailyToken> = [];
          for (var i = 0; i < this.datatables.dayTokens.length; i++) {
            let _tmpDate:Date = this.datatables.dayTokens[i].selDate;
            let _tmpDailyTokens:Array<DailyTokenItem> = [];
            
            let _indexer:number = 0;
            this.datatables.dayTokens[i].dateTokens.forEach((_tmpObj:MSCToken) => {
              _tmpDailyTokens.push(new DailyTokenItem(this.getDisplayTokenName(_tmpObj.particulars,_tmpObj.resolutionDate), this.getIdObj(_tmpDate,_indexer),''));
              _indexer++;
            });
            _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
          }
  
          this.daywiseItemList = _tmpDailyTokenList;
          this.isLoaded = true;
          this.isLoading = false;
          this.isFailed = false;
        }
        else{
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }

  private getDisplayTokenName(_ownerId:string,_resolDate:Date){
    return _ownerId;
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }

  getOwnerName(_ownerId: string): string {
    //console.log(_prodId)
    if (_ownerId)
      return this._dataService.getResponsiblePrsn(_ownerId);
    return '';
  }

  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }

  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":
      this.btnName = "Done";
      this.editRow = _param1.cloneSelf();
      this.editType = _editToken;
      this.editHeader = "Edit Focus Area (" + this.formatHeaderDate(this.dMSCDayTokenObj.selDate) +")";
      break;
      case "rownew":
      this.btnName = "Done";
      this.editRow = new MSCToken(GenService.getGUID(),'','','',(new Date(this.currMonthDtObj)).getTime(),null,null,(new Date()).getTime());
      this.editType = _editToken;
      this.editHeader = "Add Focus Area (" + this.formatHeaderDate(this.dMSCDayTokenObj.selDate) +")";
      break;
      case "selplan":
      this.btnName = "Save";
        this.editText = this.planObj.description;
        this.editType = 'text';
        this.editHeader = "Edit Plan";
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }

  public addNewProdRow(_newRowToken: string, _selDate: Date) {
    switch (_newRowToken) {
      case "rownew":
        this.showChildModal(_newRowToken,null,null);
        break;
    }
  }
  
  public removeActionDecided(_tokenIndex:number){
    this.dMSCDayTokenObj.removeToken(_tokenIndex);
    this.areChangesMade = true;
  }
  
  discardData():void{
    this.loadMonthData();
    this.loadPlan();
  }
  dataEdited() {
    switch (this.editToken) {
      case "rowedit":
        this.editParam1.job = this.editRow.job;
        this.editParam1.particulars = this.editRow.particulars;
        this.editParam1.actionDetail = this.editRow.actionDetail;
        this.editParam1.resolutionDate = this.editRow.resolutionDate;
        this.editParam1.ownerName = this.editRow.ownerName;
        this.editParam1.status = this.editRow.status;
        this.areChangesMade = true;
        break;
      case "rownew":
        this.datatables.addDateToken(new Date(this.currMonthDtObj), new MSCToken(GenService.getGUID(),this.editRow.job,this.editRow.particulars,
          this.editRow.actionDetail,this.editRow.resolutionDateNum, this.editRow.ownerName, this.editRow.status,
          this.editRow.creationDate));
        this.areChangesMade = true;

        break;
      case "selplan":
        this.datatables.plan = this.editText;
        this.planObj.description = this.editText;
        this.planObj.monthDateNum = this.currMonthDtObj.getTime();
        this.savePlan();
        break;
    }
    this.hideChildModal();
  }
  
  public prevMonthSel():void{
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }
  nextMonthSel(){
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
      this.copySelDate.setDate(this.currMonthDtObj.getDate()-1);
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
      this.copySelDate.setDate(this.currMonthDtObj.getDate()-1);
    }
  }
  loadDateData():void{
    let _tmpMSCDayToken:MSCDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    if(_tmpMSCDayToken == null){
      this.datatables.addDateToken(this.currMonthDtObj);  
      _tmpMSCDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    }
   // console.log(_tmpMSCDayToken);
    this.dMSCDayTokenObj = _tmpMSCDayToken;
  }
  // getShortageSourceName(_matShortageSrc:string){
  //   if(_matShortageSrc){
  //     if(_matShortageSrc == "grn_stic_plan") return "Green Sticker";
  //     if(_matShortageSrc == "daily_prod_high") return "Production";
  //   }
  //   return "NA";
  // }
  getParticulars(_par:string):string{
    if(_par){
      return _par
    }
    return ''
  }
  getStatus(_id:string):string{
    if(_id == "forwarded"){
      return "Forwarded";
    }
    if(_id)
      return this._dataService.getShrtgeFormStatus(_id)
    return '';
  }
  getOwner(_ownr:string):string{
    if(_ownr){
      return this._dataService.getResponsiblePrsn(_ownr);
    }
    return ''
  }
  formatMonth(_dateObj:Date):string{
    if(_dateObj){
      return GenService.getDateFormatStr(_dateObj , "MMM-YYYY");
    }
    return '-';
  }
  formatDateCmpt(_dateObj:Date):string{
    if(_dateObj){
      return GenService.getDateFormatStr(_dateObj , "DD-mmm");
    }
    return '-';
  }

  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-MMM-YYYY");
    }
    return '-';
  }
  getRespPersonStr(_respPerId:string):string{
    if(_respPerId){
      let tmpRespRef:RespPerson = this._dataService.respPersons.find((_tmpResp:RespPerson) => {
          return _tmpResp.respId == _respPerId;
        });
        if(tmpRespRef){
          return tmpRespRef.respName;
        }
    }
    return '-'
  }

  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }

  public hideChildModal():void {
    this.childModal.hide();
  }
  public discardSaveData():void{
    this.childModal.hide();
  }

  validateData():boolean{
    return true;
  }
  saveData(_sendMail:boolean):void{
    if(this.validateData()==true){
      this._dataService.saveMaterialShortage(this.datatables,_sendMail).subscribe((resp:GenResponse) => {
        if(resp.status == DataService.statusFail){
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          this._notify.success('Success',resp.details,this._dataService.successOptions);
          this.loadMonthData();
          this.loadPlan();
        }

      });
    }
  }
  openCopyModal(){ 
    this.copySelDate = new Date(this.currMonthDtObj.getTime()) 
    this.copySelDate.setDate(this.copySelDate.getDate() - 1)
    this.copyData();
  }
  prevCopyDateSel():void{
      this.copySelDate.setDate(this.copySelDate.getDate()-1);
      this.copyData();
  }
  nextCopyDateSel():void{
      this.copySelDate.setDate(this.copySelDate.getDate()+1);
      this.copyData();
  }
  copyData(){
    this.copyDataObj=null;
    this._dataService.getFocusCopyData(this.copySelDate).subscribe((_doc:MaterialShortage) => {
      if(_doc.dayTokens.length>0){  
        this.copyDataObj = _doc;
        this.loadCopyDateData();
      }
      else{
        this.CopyMSCDayTokenObj = [];
      }
    });
    this.copyModal.show();
  }
  loadCopyDateData():void{
    this.CopyMSCDayTokenObj = [];
    if(this.copyDataObj.dayTokens[0]){
      for(var i=0;i<this.copyDataObj.dayTokens[0].dateTokens.length;i++){
        let temp = this.copyDataObj.dayTokens[0].dateTokens[i];
        this.CopyMSCDayTokenObj.push(new MSCToken(GenService.getGUID(),temp.job,temp.particulars,temp.actionDetail,temp.resolutionDateNum,temp.ownerName,temp.status,temp.creationDate))
      }
    }
  }
  hideCopyChildModal(){
    this.copyModal.hide()
  }
  discardCopyData(){    
    this.CopyMSCDayTokenObj=[];
    this.hideCopyChildModal()
  }
  formatCopyHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  dataCopied(){
    for(var i=0;i<this.CopyMSCDayTokenObj.length;i++){
      this.CopyMSCDayTokenObj[i].creationDate = (new Date()).getTime();
      this.dMSCDayTokenObj.addToken(this.CopyMSCDayTokenObj[i])
    } 
    this.areChangesMade = true;
    this.discardCopyData(); 
      
  }
 

}
